function SerialPort(extensionId) {
  // Chrome App 分配的GUID
  let portGUID;
  // 使用app的ID与app建立外部连接，连接一旦建立，web端和app都想获得一个port对象
  let port = chrome.runtime.connect(extensionId);

  // 唯一的串口连接ID
  let serialConnectionId;

  // 指示串口是否打开
  let isSerialPortOpen = false;

  // 当串口接收到数据时的回调函数，undefined表示它是纯虚函数
  let onDataReceivedCallback = undefined;

  // 串口报错时的回调函数
  let onErrorReceivedCallback = undefined;

  /**
   * 监听并处理来自app的消息
   * 可以处理的消息有（可自行添加）:
   * - guid -> 当与app连接成功时app发送给web的，用于表示当前页面与app 的连接
   * - serialdata -> 当串口有新数据接收时由app发送给web
   * - serialerror -> 当串口发生错误时由app发送给web
   */
  port.onMessage.addListener(
    function (msg) {
      if (msg.header === "guid") {
        portGUID = msg.guid;
      } else if (msg.header === "serialdata") {
        if (onDataReceivedCallback !== undefined) {
          let str = dataProcess(msg);
          if (str!==undefined){
            onDataReceivedCallback(str)
          }
        }
      } else if (msg.header === "serialerror") {
        if (onErrorReceivedCallback !== undefined) {
          onErrorReceivedCallback(msg.error);
        }
      }
    }
  );



  // 检查串口是否已打开
  this.isOpen = function () {
    return isSerialPortOpen;
  }

  // 相当于纯虚函数，由web页面的callBack具体实现
  this.setOnDataReceivedCallback = function (callBack) {
    onDataReceivedCallback = callBack;
  }

  // 相当于纯虚函数，由web页面的callBack具体实现
  this.setOnErrorReceivedCallback = function (callBack) {
    onErrorReceivedCallback = callBack;
  }

  /**
   * 尝试打开一个串口
   * portInfo 必须包含以下:
   * portName  -> 串口地址
   * bitrate   -> 串口波特率
   * dataBits  -> 数据位 ("eight" or "seven")
   * parityBit -> 校验位 ("no", "odd" or "even")
   * stopBits  -> 停止位 ("one" or "two")
   * Callback用来处理app返回的结果，由于sendMessage是异步执行的函数
   */
  this.openPort = function (portInfo, callBack) {
    chrome.runtime.sendMessage(extensionId, {
        cmd: "open",
        portGUID: portGUID,
        info: portInfo
      },
      function (response) {
        if (response.result === "ok") {
          isSerialPortOpen = true;
          serialConnectionId = response.connectionInfo.connectionId;
        }
        callBack(response);
      }
    );
  }

  // 关闭一个串口
  this.closePort = function (callBack) {
    chrome.runtime.sendMessage(extensionId, {
        cmd: "close",
        connectionId: serialConnectionId
      },
      function (response) {
        if (response.result === "ok") {
          isSerialPortOpen = false;
        }
        callBack(response);
      }
    );
  };

  /**
   * 向串口写入数据
   * request 必须包含以下:
   * connectionId -> 串口连接ID
   * data         -> 要发送的字节流数组
   */
  this.write = function (data, callBack) {
    chrome.runtime.sendMessage(extensionId, {
        cmd: "write",
        connectionId: serialConnectionId,
        data: Array.prototype.slice.call(new Uint8Array(data))
      },
      function (response) {
        if (response.result === "ok") {
          if (response.sendInfo.error !== undefined) {
            if (response.sendInfo.error === "disconnected" || response.sendInfo.error === "system_error") {
              isSerialPortOpen = false;
              closePort(function () {
              });
            }
          }
        }
        callBack(response);
      }
    );
  }

  /**
   *  获取所有连接在本地PC上的串口设备列表。
   *  如果没有错误则返回以下内容:
   * - path: 物理路径
   * - vendorId (optional): 制造商ID
   * - productId (optional): 产品ID
   * - displayName (optional): 显示名称
   * Callback 用以处理app返回结果
   */
  this.getDevicesList = function getDevicesList(callBack) {
    chrome.runtime.sendMessage(extensionId, {
      cmd: "list"
    }, callBack);
  };

// 检查app是否安装在浏览器中
  function isAppInstalled(callback) {
    chrome.runtime.sendMessage(extensionId, {
        cmd: "installed"
      },
      function (response) {
        if (response) {
          callback(true);
        } else {
          callback(false);
        }
      }
    );
  }

  return this;
}

function dataProcess(msg) {
  //声明一个Uint8Array，经常被用来存放字节
  let bytes = new Uint8Array(msg.data);
  //声明空字符串
  let str = "";
  for (let i = 0; i < bytes.length; i++) {
    //用16进制表示字节
    let k = bytes[i].toString(16);
    //如果只有1位在前面补0
    if (k.length === 1) k = "0" + k;
    //储存为URI格式
    str += "%" + k
  }
  //output就是bytes转换后的string啦！
  str = decodeURI(str);
  console.log(str);
  try {
    if (str === 'w' || str === 'wn') {
      return;
    }

    if (str.includes("kg")) {
      str = str.replace("wn", "").replace("n", "").replace("kg", "");
      str = parseFloat(str);
    } else {
      // .split("").reverse().join("")
      str = decodeURIComponent(str);

      if (str.includes("=")) {
        str = parseFloat(str.replace("=", "").split("").reverse().join(""))
      } else {
        str = parseFloat(str);
      }
      /// 1000
    }
    return str;
  } catch (e) {
    console.log(e);
  }
}

module.exports = {
  dataProcess,
  SerialPort
};



// WEBPACK FOOTER //
// ./src/plugin/serialPort.js